import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';

const Withdraw = () => {
  const { id, userId } = useParams();

  const [formData, setFormData] = useState({
    amount: '',
    paymentMethod: 'points',
  });

  const [transactions, setTransactions] = useState([]);
  const [totalWithdraw, setTotalWithdraw] = useState(0);

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const fetchTransactions = async () => {
    try {
      const res = await axios.get(`https://api.happychd.com/api/user/${id}`);
      const allWithdrawals = res.data.transactions?.filter((tx) => tx.type === 'withdraw') || [];

      setTransactions(allWithdrawals);
      const total = allWithdrawals.reduce((sum, tx) => sum + tx.amount, 0);
      setTotalWithdraw(total);
    } catch (err) {
      console.error('Error fetching transactions:', err.message);
    }
  };

  const handleWithdraw = async (e) => {
    e.preventDefault();
    if (!id) return;

    const { amount, paymentMethod } = formData;

    if (!window.confirm(`Are you sure you want to withdraw ₹${amount} from user ${userId}?`)) return;

    try {
      const response = await axios.patch(`https://api.happychd.com/api/user/transaction/${id}`, {
        type: 'withdraw',
        amount: parseFloat(amount),
        paymentMethod,
        date: new Date(),
      });

      alert(`✅ ${response.data.message}\nNew Balance: ₹${response.data.netBalance}`);
      setFormData({ amount: '', paymentMethod: 'points' });
      fetchTransactions(); // Refresh list after new withdraw
    } catch (error) {
      alert(`❌ Failed to withdraw: ${error.response?.data?.message || error.message}`);
    }
  };

  useEffect(() => {
    fetchTransactions();
  }, [id]);

  const formatDate = (dateStr) =>
    new Date(dateStr).toLocaleDateString('en-IN', {
      weekday: 'short',   // Adds day like 'Mon', 'Tue'
      day: 'numeric',
      month: 'short',
      year: 'numeric',
    });

  return (
    <div className="p-6 max-w-auto mx-auto">
        <h2 className="text-2xl font-bold mb-6 text-red-600 text-center">Withdraw from {userId}</h2>

        {/* Centered Form */}
        <div className="flex justify-center">
          <form onSubmit={handleWithdraw} className="space-y-4 w-full max-w-md bg-white shadow-md rounded-lg p-6 border">
            <input
              type="number"
              name="amount"
              value={formData.amount}
              onChange={handleChange}
              placeholder="Amount (INR)"
              className="border w-full px-4 py-2 rounded"
              required
            />
            <select
              name="paymentMethod"
              value={formData.paymentMethod}
              onChange={handleChange}
              className="border w-full px-4 py-2 rounded"
              required
            >
              <option value="points">Points</option>
              <option value="cash">Cash</option>
              <option value="upi">UPI</option>
              <option value="bank">Bank</option>
              <option value="card">Card</option>
            </select>
            <button type="submit" className="bg-red-500 hover:bg-red-600 text-white px-4 py-2 rounded w-full">
              Confirm Withdraw
            </button>
          </form>
        </div>

        {/* Total Withdraw Summary */}
        <div className="mt-10 text-xl font-semibold text-red-700">
          💸 Total Withdrawn Amount: ₹{totalWithdraw.toFixed(2)}
        </div>

        {/* Withdraw Transactions Table */}
        <div className="mt-6 overflow-x-auto">
          <table className="w-full border text-sm text-left">
            <thead className="bg-gray-100">
              <tr>
                <th className="p-2 border">#</th>
                <th className="p-2 border">Amount (₹)</th>
                <th className="p-2 border">Method</th>
                <th className="p-2 border">Date</th>
              </tr>
            </thead>
            <tbody>
              {transactions.map((tx, index) => (
                <tr key={tx._id}>
                  <td className="p-2 border">{index + 1}</td>
                  <td className="p-2 border">{tx.amount}</td>
                  <td className="p-2 border capitalize">{tx.paymentMethod}</td>
                  <td className="p-2 border">{formatDate(tx.date)}</td>
                </tr>
              ))}
              {transactions.length === 0 && (
                <tr>
                  <td colSpan="4" className="text-center p-4 text-gray-500">
                    No withdrawal transactions found.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
  );
};

export default Withdraw;
